@if (orderFound && !loading && !saved && !error && !saving) {
  <h2 mat-dialog-title>{{ 'orders.copyPartiesFromRegistration' | transloco: { number: number } }}</h2>
}
<mat-dialog-content>
  @if (loading || this.saving) {
    <div class="loading-spinner-overlay">
      <mat-spinner></mat-spinner>
    </div>
  } @else {
    @if (orderFound) {
      <div>
        @if (!saving && !saved) {
          <div>
            <table mat-table [dataSource]="parties$" multiTemplateDataRows class="fixed-table"
              data-testid="parties-table">
              <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef> </th>
                <td mat-cell *matCellDef="let party">
                  <mat-checkbox (change)="onSelectionChange(party)"></mat-checkbox>
                </td>
              </ng-container>
              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>{{ 'common.labels.name' | transloco }}</th>
                <td mat-cell *matCellDef="let party" [innerHTML]="this.getName(party)"
                  data-testid="parties-name-text">
                </td>
              </ng-container>
              <ng-container matColumnDef="party-type">
                <th mat-header-cell *matHeaderCellDef>{{ 'common.labels.type' | transloco }}</th>
                <td mat-cell *matCellDef="let party">
                  {{ getPartyTypeString(party) }}
                </td>
              </ng-container>
              <ng-container matColumnDef="contactDetails">
                <th mat-header-cell *matHeaderCellDef>{{ 'common.labels.contactDetails' | transloco }}</th>
                <td mat-cell *matCellDef="let party">
                  <span [innerHTML]="this.getContactDetails(party)" data-testid="parties-contact-text"></span>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr #partyTableBodyRow mat-row *matRowDef="let party; columns: displayedColumns;">
              </tr>
            </table>
          </div>
        }
        @if (!saving && saved) {
          <div>
            <div class="center-a-div">
              <lib-placeholder [condition]="true" iconName="check_circle" iconClass="icon-success" [message]="'orders.partiesSaved' | transloco"></lib-placeholder>
            </div>
          </div>
        }
        @if (!saving && error) {
          <div>
            <div class="center-a-div">
              <lib-placeholder iconName="cancel" iconClass="icon-error" [message]="'orders.failedToCopyPartiesPleaseEnter' | transloco"></lib-placeholder>
            </div>
          </div>
        }
      </div>
    } @else {
      <div class="center-a-div">
        <span class="text-faded">{{ 'orders.noOrdersWithRegistrationNumber' | transloco: { number: number } }}</span>
      </div>
    }
  }

</mat-dialog-content>

<mat-dialog-actions class="flex-container-right-align">
  <div class="spacer"></div>
  @if (orderFound && !saving && !loading && !saved && !error) {
    <button class="flex-item-1" mat-raised-button color="primary" (click)="onCopySelected()">{{ 'orders.copySelected' | transloco }}</button>
  }
  @if (!loading && !saving) {
    <button class="flex-item-fixed-size" mat-raised-button [mat-dialog-close]="true">{{ 'common.buttons.close' | transloco }}</button>
  }
</mat-dialog-actions>